export const plushieData = [
  {
    "name": "Scarworld Season 4",
    "code": "scarworld-s4",
    "plushies": [
      {
        "name": "Amicamelia284",
        "path": "scarworld/4/Amicamelia284"
      },
      {
        "name": "BabyKillBill",
        "path": "scarworld/4/BabyKillBill"
      },
      {
        "name": "Barstana",
        "path": "scarworld/4/Barstana"
      },
      {
        "name": "BaydleOG",
        "path": "scarworld/4/BaydleOG"
      },
      {
        "name": "BeanBot_10",
        "path": "scarworld/4/BeanBot_10"
      },
      {
        "name": "BestMarsBotanist",
        "path": "scarworld/4/BestMarsBotanist"
      },
      {
        "name": "Blue6erry",
        "path": "scarworld/4/Blue6erry"
      },
      {
        "name": "BlueStarFlwr",
        "path": "scarworld/4/BlueStarFlwr"
      },
      {
        "name": "Bluecrow642",
        "path": "scarworld/4/Bluecrow642"
      },
      {
        "name": "BossyBear",
        "path": "scarworld/4/BossyBear"
      },
      {
        "name": "BossyHare",
        "path": "scarworld/4/BossyHare"
      },
      {
        "name": "Boyguna",
        "path": "scarworld/4/Boyguna"
      },
      {
        "name": "BunnyQueen456",
        "path": "scarworld/4/BunnyQueen456"
      },
      {
        "name": "Carden_F",
        "path": "scarworld/4/Carden_F"
      },
      {
        "name": "CaptainOslo",
        "path": "scarworld/4/CaptainOslo"
      },
      {
        "name": "Cattootler",
        "path": "scarworld/4/Cattootler"
      },
      {
        "name": "CheshXMD",
        "path": "scarworld/4/CheshXMD"
      },
      {
        "name": "Chrisnessity",
        "path": "scarworld/4/Chrisnessity"
      },
      {
        "name": "ChronicallyCrfty",
        "path": "scarworld/4/ChronicallyCrfty"
      },
      {
        "name": "Cozy_Toasty",
        "path": "scarworld/4/Cozy_Toasty"
      },
      {
        "name": "CosmicLibrarian",
        "path": "scarworld/4/CosmicLibrarian"
      },
      {
        "name": "Crashbreaka",
        "path": "scarworld/4/Crashbreaka"
      },
      {
        "name": "CrowDessa",
        "path": "scarworld/4/CrowDessa"
      },
      {
        "name": "D_Dog_07",
        "path": "scarworld/4/D_Dog_07"
      },
      {
        "name": "Dewlan",
        "path": "scarworld/4/Dewlan"
      },
      {
        "name": "Dman1667",
        "path": "scarworld/4/Dman1667"
      },
      {
        "name": "DuckOmega",
        "path": "scarworld/4/DuckOmega"
      },
      {
        "name": "DyedByFire",
        "path": "scarworld/4/DyedByFire"
      },
      {
        "name": "Electra310",
        "path": "scarworld/4/Electra310"
      },
      {
        "name": "EpicBlueMouse",
        "path": "scarworld/4/EpicBlueMouse"
      },
      {
        "name": "FCDad",
        "path": "scarworld/4/FCDad"
      },
      {
        "name": "FGTFLHamster",
        "path": "scarworld/4/FGTFLHamster"
      },
      {
        "name": "FighterJockey",
        "path": "scarworld/4/FighterJockey"
      },
      {
        "name": "Firedemon80",
        "path": "scarworld/4/Firedemon80"
      },
      {
        "name": "FreehandFox556",
        "path": "scarworld/4/FreehandFox556"
      },
      {
        "name": "GoodTimeWithScar",
        "path": "scarworld/4/GoodTimeWithScar"
      },
      {
        "name": "HardcoreOboist",
        "path": "scarworld/4/HardcoreOboist"
      },
      {
        "name": "H3r0d",
        "path": "scarworld/4/H3r0d"
      },
      {
        "name": "IggyTheImp1",
        "path": "scarworld/4/IggyTheImp1"
      },
      {
        "name": "Im_Jenny",
        "path": "scarworld/4/Im_Jenny"
      },
      {
        "name": "Ivan_Minecrafter",
        "path": "scarworld/4/Ivan_Minecrafter"
      },
      {
        "name": "JarvicJ",
        "path": "scarworld/4/JarvicJ"
      },
      {
        "name": "Jellie",
        "path": "scarworld/4/Jellie"
      },
      {
        "name": "Jillybean52371",
        "path": "scarworld/4/Jillybean52371"
      },
      {
        "name": "JoshGriggs",
        "path": "scarworld/4/JoshGriggs"
      },
      {
        "name": "Kageriu",
        "path": "scarworld/4/Kageriu"
      },
      {
        "name": "Kimmers_mouse",
        "path": "scarworld/4/Kimmers_mouse"
      },
      {
        "name": "KingKergi",
        "path": "scarworld/4/KingKergi"
      },
      {
        "name": "Koptellefon",
        "path": "scarworld/4/Koptellefon"
      },
      {
        "name": "Kozenbi",
        "path": "scarworld/4/Kozenbi"
      },
      {
        "name": "Kysaeri",
        "path": "scarworld/4/Kysaeri"
      },
      {
        "name": "Lavandua",
        "path": "scarworld/4/Lavandua"
      },
      {
        "name": "LeeLeeDee",
        "path": "scarworld/4/LeeLeeDee"
      },
      {
        "name": "Loddie",
        "path": "scarworld/4/Loddie"
      },
      {
        "name": "MaddiG359",
        "path": "scarworld/4/MaddiG359"
      },
      {
        "name": "Madiza",
        "path": "scarworld/4/Madiza"
      },
      {
        "name": "MaddenChan",
        "path": "scarworld/4/MaddenChan"
      },
      {
        "name": "Maskom",
        "path": "scarworld/4/Maskom"
      },
      {
        "name": "MaziCrafter",
        "path": "scarworld/4/MaziCrafter"
      },
      {
        "name": "Mazoodle1234",
        "path": "scarworld/4/Mazoodle1234"
      },
      {
        "name": "MilitantImp3943",
        "path": "scarworld/4/MilitantImp3943"
      },
      {
        "name": "Mitch4229",
        "path": "scarworld/4/Mitch4229"
      },
      {
        "name": "ModigMaestro",
        "path": "scarworld/4/ModigMaestro"
      },
      {
        "name": "ObiWanTano",
        "path": "scarworld/4/ObiWanTano"
      },
      {
        "name": "Oldmin",
        "path": "scarworld/4/Oldmin"
      },
      {
        "name": "OracleMask",
        "path": "scarworld/4/OracleMask"
      },
      {
        "name": "PinkCreeper18",
        "path": "scarworld/4/PinkCreeper18"
      },
      {
        "name": "Py_thagore",
        "path": "scarworld/4/Py_thagore"
      },
      {
        "name": "QueenieCrafter",
        "path": "scarworld/4/QueenieCrafter"
      },
      {
        "name": "Queenjitters",
        "path": "scarworld/4/Queenjitters"
      },
      {
        "name": "Razoria",
        "path": "scarworld/4/Razoria"
      },
      {
        "name": "RedIsFun",
        "path": "scarworld/4/RedIsFun"
      },
      {
        "name": "RegulusSir",
        "path": "scarworld/4/RegulusSir"
      },
      {
        "name": "ShadowStar1313",
        "path": "scarworld/4/ShadowStar1313"
      },
      {
        "name": "SuperTrooper78",
        "path": "scarworld/4/SuperTrooper78"
      },
      {
        "name": "Syndeku",
        "path": "scarworld/4/Syndeku"
      },
      {
        "name": "TaylorHDGaming",
        "path": "scarworld/4/TaylorHDGaming"
      },
      {
        "name": "TempestTaco6306",
        "path": "scarworld/4/TempestTaco6306"
      },
      {
        "name": "Terraglows",
        "path": "scarworld/4/Terraglows"
      },
      {
        "name": "TheWhysGuy",
        "path": "scarworld/4/TheWhysGuy"
      },
      {
        "name": "Thwaite5516",
        "path": "scarworld/4/Thwaite5516"
      },
      {
        "name": "Tuelezianking",
        "path": "scarworld/4/Tuelezianking"
      },
      {
        "name": "Uni_Kitty4788",
        "path": "scarworld/4/Uni_Kitty4788"
      },
      {
        "name": "Vindalfur",
        "path": "scarworld/4/Vindalfur"
      },
      {
        "name": "Wishingwell1975",
        "path": "scarworld/4/Wishingwell1975"
      },
      {
        "name": "WolfBrotherPC",
        "path": "scarworld/4/WolfBrotherPC"
      },
      {
        "name": "XhyRobtic",
        "path": "scarworld/4/XhyRobtic"
      },
      {
        "name": "YetiWhiskers",
        "path": "scarworld/4/YetiWhiskers"
      },
      {
        "name": "ZaneHayami",
        "path": "scarworld/4/ZaneHayami"
      },
      {
        "name": "_keldric_",
        "path": "scarworld/4/_keldric_"
      },
      {
        "name": "assassin_plays",
        "path": "scarworld/4/assassin_plays"
      },
      {
        "name": "captaincorey",
        "path": "scarworld/4/captaincorey"
      },
      {
        "name": "cloudninemeeple",
        "path": "scarworld/4/cloudninemeeple"
      },
      {
        "name": "colocha",
        "path": "scarworld/4/colocha"
      },
      {
        "name": "fightingseabee",
        "path": "scarworld/4/fightingseabee"
      },
      {
        "name": "gutchess",
        "path": "scarworld/4/gutchess"
      },
      {
        "name": "herossong",
        "path": "scarworld/4/herossong"
      },
      {
        "name": "hoverfloat",
        "path": "scarworld/4/hoverfloat"
      },
      {
        "name": "iomoon",
        "path": "scarworld/4/iomoon"
      },
      {
        "name": "joecool12",
        "path": "scarworld/4/joecool12"
      },
      {
        "name": "joecool12 V2",
        "path": "scarworld/4/joecool12-v2"
      },
      {
        "name": "kennywarrix",
        "path": "scarworld/4/kennywarrix"
      },
      {
        "name": "lol1o1",
        "path": "scarworld/4/lol1o1"
      },
      {
        "name": "martin_smartin",
        "path": "scarworld/4/martin_smartin"
      },
      {
        "name": "nicklas_ck",
        "path": "scarworld/4/nicklas_ck"
      },
      {
        "name": "nonbinarymermaid",
        "path": "scarworld/4/nonbinarymermaid"
      },
      {
        "name": "rascalwolf",
        "path": "scarworld/4/rascalwolf"
      },
      {
        "name": "rcmrocks",
        "path": "scarworld/4/rcmrocks"
      },
      {
        "name": "rizabeth",
        "path": "scarworld/4/rizabeth"
      },
      {
        "name": "squibitbessy",
        "path": "scarworld/4/squibitbessy"
      },
      {
        "name": "supermario10274",
        "path": "scarworld/4/supermario10274"
      },
      {
        "name": "zeppelinmage",
        "path": "scarworld/4/zeppelinmage"
      }
    ]
  },
  {
    "name": "Scarworld Season 5",
    "code": "scarworld-s5",
    "plushies": [
      {
        "name": "4leap",
        "path": "scarworld/5/4leap"
      },
      {
        "name": "_Keldric_",
        "path": "scarworld/5/_Keldric_"
      },
      {
        "name": "Alw4ysG4ming",
        "path": "scarworld/5/Alw4ysG4ming"
      },
      {
        "name": "Amicamelia284",
        "path": "scarworld/5/Amicamelia284"
      },
      {
        "name": "Ancient_Londro",
        "path": "scarworld/5/Ancient_Londro"
      },
      {
        "name": "Arteleha",
        "path": "scarworld/5/Arteleha"
      },
      {
        "name": "assassin_plays",
        "path": "scarworld/5/assassin_plays"
      },
      {
        "name": "AyEmEff",
        "path": "scarworld/5/AyEmEff"
      },
      {
        "name": "Ayyzee",
        "path": "scarworld/5/Ayyzee"
      },
      {
        "name": "BabyKillBill",
        "path": "scarworld/5/BabyKillBill"
      },
      {
        "name": "Baychimo",
        "path": "scarworld/5/Baychimo"
      },
      {
        "name": "BaydleOG",
        "path": "scarworld/5/BaydleOG"
      },
      {
        "name": "Berrand",
        "path": "scarworld/5/Berrand"
      },
      {
        "name": "BestMarsBotanist",
        "path": "scarworld/5/BestMarsBotanist"
      },
      {
        "name": "Blue6erry",
        "path": "scarworld/5/Blue6erry"
      },
      {
        "name": "Blue_Shift",
        "path": "scarworld/5/Blue_Shift"
      },
      {
        "name": "Blueastrosailor",
        "path": "scarworld/5/Blueastrosailor"
      },
      {
        "name": "Bluecrow642",
        "path": "scarworld/5/Bluecrow642"
      },
      {
        "name": "Bluelighting76",
        "path": "scarworld/5/Bluelighting76"
      },
      {
        "name": "bopig",
        "path": "scarworld/5/bopig"
      },
      {
        "name": "BossyBear",
        "path": "scarworld/5/BossyBear"
      },
      {
        "name": "BossyHare",
        "path": "scarworld/5/BossyHare"
      },
      {
        "name": "Boyguna",
        "path": "scarworld/5/Boyguna"
      },
      {
        "name": "Braemma",
        "path": "scarworld/5/Braemma"
      },
      {
        "name": "BreeNix",
        "path": "scarworld/5/BreeNix"
      },
      {
        "name": "ByoumaNeko",
        "path": "scarworld/5/ByoumaNeko"
      },
      {
        "name": "calcreative",
        "path": "scarworld/5/calcreative"
      },
      {
        "name": "CamoDaveYT",
        "path": "scarworld/5/CamoDaveYT"
      },
      {
        "name": "candleSM",
        "path": "scarworld/5/candleSM"
      },
      {
        "name": "captaincorey",
        "path": "scarworld/5/captaincorey"
      },
      {
        "name": "CaptainOslo",
        "path": "scarworld/5/CaptainOslo"
      },
      {
        "name": "CardenF",
        "path": "scarworld/5/CardenF"
      },
      {
        "name": "Cat1dog",
        "path": "scarworld/5/Cat1dog"
      },
      {
        "name": "Cattootler",
        "path": "scarworld/5/Cattootler"
      },
      {
        "name": "Celestial17",
        "path": "scarworld/5/Celestial17"
      },
      {
        "name": "ChaoticKaiju",
        "path": "scarworld/5/ChaoticKaiju"
      },
      {
        "name": "charp021",
        "path": "scarworld/5/charp021"
      },
      {
        "name": "CheshXMD",
        "path": "scarworld/5/CheshXMD"
      },
      {
        "name": "Chrisnessity",
        "path": "scarworld/5/Chrisnessity"
      },
      {
        "name": "ChronicallyCrfty",
        "path": "scarworld/5/ChronicallyCrfty"
      },
      {
        "name": "ChronicallyCrfty V2",
        "path": "scarworld/5/ChronicallyCrfty_v2"
      },
      {
        "name": "cloudninemeeple",
        "path": "scarworld/5/cloudninemeeple"
      },
      {
        "name": "Condude54",
        "path": "scarworld/5/Condude54"
      },
      {
        "name": "CosmicLibrarian",
        "path": "scarworld/5/CosmicLibrarian"
      },
      {
        "name": "CosplayBob",
        "path": "scarworld/5/CosplayBob"
      },
      {
        "name": "Cotenzia",
        "path": "scarworld/5/Cotenzia"
      },
      {
        "name": "Crashbreaka",
        "path": "scarworld/5/Crashbreaka"
      },
      {
        "name": "Crescensph",
        "path": "scarworld/5/Crescensph"
      },
      {
        "name": "CrowDessa",
        "path": "scarworld/5/CrowDessa"
      },
      {
        "name": "CurtTheRed",
        "path": "scarworld/5/CurtTheRed"
      },
      {
        "name": "CXMEWITHME",
        "path": "scarworld/5/CXMEWITHME"
      },
      {
        "name": "Dalienated",
        "path": "scarworld/5/Dalienated"
      },
      {
        "name": "Darkking6833",
        "path": "scarworld/5/Darkking6833"
      },
      {
        "name": "Darkwytch2",
        "path": "scarworld/5/Darkwytch2"
      },
      {
        "name": "davesandstorm",
        "path": "scarworld/5/davesandstorm"
      },
      {
        "name": "DesertDog666",
        "path": "scarworld/5/DesertDog666"
      },
      {
        "name": "Dewlan",
        "path": "scarworld/5/Dewlan"
      },
      {
        "name": "DuckOmega",
        "path": "scarworld/5/DuckOmega"
      },
      {
        "name": "DuplicitDragon",
        "path": "scarworld/5/DuplicitDragon"
      },
      {
        "name": "DyedByFire",
        "path": "scarworld/5/DyedByFire"
      },
      {
        "name": "Edee3",
        "path": "scarworld/5/Edee3"
      },
      {
        "name": "Electra310",
        "path": "scarworld/5/Electra310"
      },
      {
        "name": "ElectricShmoo",
        "path": "scarworld/5/ElectricShmoo"
      },
      {
        "name": "EndlessStormWolf",
        "path": "scarworld/5/EndlessStormWolf"
      },
      {
        "name": "EpicBlueMouse",
        "path": "scarworld/5/EpicBlueMouse"
      },
      {
        "name": "Eriffee",
        "path": "scarworld/5/Eriffee"
      },
      {
        "name": "expertProofreadr",
        "path": "scarworld/5/expertProofreadr"
      },
      {
        "name": "Falkun",
        "path": "scarworld/5/Falkun"
      },
      {
        "name": "FCDad",
        "path": "scarworld/5/FCDad"
      },
      {
        "name": "FGTFLHamster",
        "path": "scarworld/5/FGTFLHamster"
      },
      {
        "name": "Firedemon80",
        "path": "scarworld/5/Firedemon80"
      },
      {
        "name": "FreehandFox556",
        "path": "scarworld/5/FreehandFox556"
      },
      {
        "name": "Fungi_2022",
        "path": "scarworld/5/Fungi_2022"
      },
      {
        "name": "GemSongRS",
        "path": "scarworld/5/GemSongRS"
      },
      {
        "name": "gentlywithachain",
        "path": "scarworld/5/gentlywithachain"
      },
      {
        "name": "gladra",
        "path": "scarworld/5/gladra"
      },
      {
        "name": "GlasSandPlane",
        "path": "scarworld/5/GlasSandPlane"
      },
      {
        "name": "GlasSandPlane (Alt)",
        "path": "scarworld/5/GlasSandPlane_alt"
      },
      {
        "name": "Godofmischief",
        "path": "scarworld/5/Godofmischief"
      },
      {
        "name": "gutchess",
        "path": "scarworld/5/gutchess"
      },
      {
        "name": "H3r0d",
        "path": "scarworld/5/H3r0d"
      },
      {
        "name": "HardcoreOboist",
        "path": "scarworld/5/HardcoreOboist"
      },
      {
        "name": "HendoHendo",
        "path": "scarworld/5/HendoHendo"
      },
      {
        "name": "hollz13725",
        "path": "scarworld/5/hollz13725"
      },
      {
        "name": "hoverfloat",
        "path": "scarworld/5/hoverfloat"
      },
      {
        "name": "Im_Jenny",
        "path": "scarworld/5/Im_Jenny"
      },
      {
        "name": "ImperialReject",
        "path": "scarworld/5/ImperialReject"
      },
      {
        "name": "iomoon",
        "path": "scarworld/5/iomoon"
      },
      {
        "name": "Ivan_Minecrafter",
        "path": "scarworld/5/Ivan_Minecrafter"
      },
      {
        "name": "Jera_Wizard",
        "path": "scarworld/5/Jera_Wizard"
      },
      {
        "name": "joecool12",
        "path": "scarworld/5/joecool12"
      },
      {
        "name": "JoshGriggs",
        "path": "scarworld/5/JoshGriggs"
      },
      {
        "name": "Kageriu",
        "path": "scarworld/5/Kageriu"
      },
      {
        "name": "Kasbak",
        "path": "scarworld/5/Kasbak"
      },
      {
        "name": "KidaBarbie",
        "path": "scarworld/5/KidaBarbie"
      },
      {
        "name": "KidaBerry",
        "path": "scarworld/5/KidaBerry"
      },
      {
        "name": "Kimmers_mouse",
        "path": "scarworld/5/Kimmers_mouse"
      },
      {
        "name": "KingKergi",
        "path": "scarworld/5/KingKergi"
      },
      {
        "name": "KiraPlaysFF",
        "path": "scarworld/5/KiraPlaysFF"
      },
      {
        "name": "kisha82",
        "path": "scarworld/5/kisha82"
      },
      {
        "name": "Kubo_k",
        "path": "scarworld/5/Kubo_k"
      },
      {
        "name": "Kysaeri",
        "path": "scarworld/5/Kysaeri"
      },
      {
        "name": "Lavandua",
        "path": "scarworld/5/Lavandua"
      },
      {
        "name": "LivAwesome",
        "path": "scarworld/5/LivAwesome"
      },
      {
        "name": "Loddie",
        "path": "scarworld/5/Loddie"
      },
      {
        "name": "LordVonWolf",
        "path": "scarworld/5/LordVonWolf"
      },
      {
        "name": "Lupa_Buchanan",
        "path": "scarworld/5/Lupa_Buchanan"
      },
      {
        "name": "MaddenChan",
        "path": "scarworld/5/MaddenChan"
      },
      {
        "name": "Madiza",
        "path": "scarworld/5/Madiza"
      },
      {
        "name": "MadizaMonster",
        "path": "scarworld/5/MadizaMonster"
      },
      {
        "name": "Maggiee",
        "path": "scarworld/5/Maggiee"
      },
      {
        "name": "MajesticGazelles",
        "path": "scarworld/5/MajesticGazelles"
      },
      {
        "name": "martin_smartin",
        "path": "scarworld/5/martin_smartin"
      },
      {
        "name": "Maskom",
        "path": "scarworld/5/Maskom"
      },
      {
        "name": "Mazaradie",
        "path": "scarworld/5/Mazaradie"
      },
      {
        "name": "MaziCrafter",
        "path": "scarworld/5/MaziCrafter"
      },
      {
        "name": "Mazoodle1234",
        "path": "scarworld/5/Mazoodle1234"
      },
      {
        "name": "Mia09Minecraft",
        "path": "scarworld/5/Mia09Minecraft"
      },
      {
        "name": "Mipronk",
        "path": "scarworld/5/Mipronk"
      },
      {
        "name": "Mitch4229",
        "path": "scarworld/5/Mitch4229"
      },
      {
        "name": "MithicalMoon",
        "path": "scarworld/5/MithicalMoon"
      },
      {
        "name": "MiyaMichy",
        "path": "scarworld/5/MiyaMichy"
      },
      {
        "name": "ModigMaestro",
        "path": "scarworld/5/ModigMaestro"
      },
      {
        "name": "MsKakapo",
        "path": "scarworld/5/MsKakapo"
      },
      {
        "name": "NajaNaja",
        "path": "scarworld/5/NajaNaja"
      },
      {
        "name": "nerdcatbuilds",
        "path": "scarworld/5/nerdcatbuilds"
      },
      {
        "name": "nicklas_c",
        "path": "scarworld/5/nicklas_c"
      },
      {
        "name": "NickSkyKnight",
        "path": "scarworld/5/NickSkyKnight"
      },
      {
        "name": "ObiWanTano",
        "path": "scarworld/5/ObiWanTano"
      },
      {
        "name": "oceanflan_",
        "path": "scarworld/5/oceanflan_"
      },
      {
        "name": "Oldmin",
        "path": "scarworld/5/Oldmin"
      },
      {
        "name": "Onigiri_Aoi",
        "path": "scarworld/5/Onigiri_Aoi"
      },
      {
        "name": "OracleMask",
        "path": "scarworld/5/OracleMask"
      },
      {
        "name": "OriahTM",
        "path": "scarworld/5/OriahTM"
      },
      {
        "name": "Ortwyn",
        "path": "scarworld/5/Ortwyn"
      },
      {
        "name": "Ottergal",
        "path": "scarworld/5/Ottergal"
      },
      {
        "name": "parker201",
        "path": "scarworld/5/parker201"
      },
      {
        "name": "PerfectlyFlawed_",
        "path": "scarworld/5/PerfectlyFlawed_"
      },
      {
        "name": "PerfectlyFlawed V2",
        "path": "scarworld/5/PerfectlyFlawed_v2"
      },
      {
        "name": "PhoenixBunny456",
        "path": "scarworld/5/PhoenixBunny456"
      },
      {
        "name": "PIGLET1706",
        "path": "scarworld/5/PIGLET1706"
      },
      {
        "name": "PinkCreeper18",
        "path": "scarworld/5/PinkCreeper18"
      },
      {
        "name": "ProfessorP81",
        "path": "scarworld/5/ProfessorP81"
      },
      {
        "name": "Purpl3Skies",
        "path": "scarworld/5/Purpl3Skies"
      },
      {
        "name": "Py_thagore",
        "path": "scarworld/5/Py_thagore"
      },
      {
        "name": "QueenieCrafter",
        "path": "scarworld/5/QueenieCrafter"
      },
      {
        "name": "Queenjitters",
        "path": "scarworld/5/Queenjitters"
      },
      {
        "name": "RailwayJanni",
        "path": "scarworld/5/RailwayJanni"
      },
      {
        "name": "RainbowLight07",
        "path": "scarworld/5/RainbowLight07"
      },
      {
        "name": "Rascalwolf",
        "path": "scarworld/5/rascalwolf"
      },
      {
        "name": "Razoria",
        "path": "scarworld/5/Razoria"
      },
      {
        "name": "RedPandaRamen_",
        "path": "scarworld/5/RedPandaRamen_"
      },
      {
        "name": "RegulusSir",
        "path": "scarworld/5/RegulusSir"
      },
      {
        "name": "RexEtImperator",
        "path": "scarworld/5/RexEtImperator"
      },
      {
        "name": "rizabeth",
        "path": "scarworld/5/rizabeth"
      },
      {
        "name": "satyen00",
        "path": "scarworld/5/satyen00"
      },
      {
        "name": "ScarrredForLife",
        "path": "scarworld/5/ScarrredForLife"
      },
      {
        "name": "ShadowStar1313",
        "path": "scarworld/5/ShadowStar1313"
      },
      {
        "name": "shnozberrycake",
        "path": "scarworld/5/shnozberrycake"
      },
      {
        "name": "Shortrange83",
        "path": "scarworld/5/Shortrange83"
      },
      {
        "name": "Sinopa1327",
        "path": "scarworld/5/Sinopa1327"
      },
      {
        "name": "SkunkFloof",
        "path": "scarworld/5/SkunkFloof"
      },
      {
        "name": "Squibitbessy",
        "path": "scarworld/5/Squibitbessy"
      },
      {
        "name": "Sr_Cro",
        "path": "scarworld/5/Sr_Cro"
      },
      {
        "name": "steppe04",
        "path": "scarworld/5/steppe04"
      },
      {
        "name": "StoneOmega1327",
        "path": "scarworld/5/StoneOmega1327"
      },
      {
        "name": "Stormhawke7",
        "path": "scarworld/5/Stormhawke7"
      },
      {
        "name": "SuperTrooper78",
        "path": "scarworld/5/SuperTrooper78"
      },
      {
        "name": "SweepyDub",
        "path": "scarworld/5/SweepyDub"
      },
      {
        "name": "Syndeku",
        "path": "scarworld/5/Syndeku"
      },
      {
        "name": "Tacobor",
        "path": "scarworld/5/Tacobor"
      },
      {
        "name": "TaylorHDGaming",
        "path": "scarworld/5/TaylorHDGaming"
      },
      {
        "name": "Terraglows",
        "path": "scarworld/5/Terraglows"
      },
      {
        "name": "theosist",
        "path": "scarworld/5/theosist"
      },
      {
        "name": "TheRealStalker",
        "path": "scarworld/5/TheRealStalker"
      },
      {
        "name": "ThrowTheSwitch",
        "path": "scarworld/5/ThrowTheSwitch"
      },
      {
        "name": "Thwaite5516",
        "path": "scarworld/5/Thwaite5516"
      },
      {
        "name": "tippster1992",
        "path": "scarworld/5/tippster1992"
      },
      {
        "name": "Tmberwolff",
        "path": "scarworld/5/Tmberwolff"
      },
      {
        "name": "TuelezianKing",
        "path": "scarworld/5/TuelezianKing"
      },
      {
        "name": "Uni_Kitty4788",
        "path": "scarworld/5/Uni_Kitty4788"
      },
      {
        "name": "Vindalfur",
        "path": "scarworld/5/Vindalfur"
      },
      {
        "name": "Wolos",
        "path": "scarworld/5/Wolos"
      },
      {
        "name": "xALFRODOx",
        "path": "scarworld/5/xALFRODOx"
      },
      {
        "name": "XhyRobtic",
        "path": "scarworld/5/XhyRobtic"
      },
      {
        "name": "YellowPikmin",
        "path": "scarworld/5/YellowPikmin"
      },
      {
        "name": "YetiWhiskers",
        "path": "scarworld/5/YetiWhiskers"
      },
      {
        "name": "ZaneHayami",
        "path": "scarworld/5/ZaneHayami"
      },
      {
        "name": "zeppelinmage",
        "path": "scarworld/5/zeppelinmage"
      }
    ]
  },
  {
    "name": "Scarworld Season 6",
    "code": "scarworld-s6",
    "plushies": [
      {
        "name": "__vast",
        "path": "scarworld/6/__vast"
      },
      {
        "name": "_Maylia",
        "path": "scarworld/6/_Maylia"
      },
      {
        "name": "Advanced24",
        "path": "scarworld/6/Advanced24"
      },
      {
        "name": "Amicamelia284",
        "path": "scarworld/6/Amicamelia284"
      },
      {
        "name": "Ancient_Londro",
        "path": "scarworld/6/Ancient_Londro"
      },
      {
        "name": "BaydleOG",
        "path": "scarworld/6/BaydleOG"
      },
      {
        "name": "Berrand",
        "path": "scarworld/6/Berrand"
      },
      {
        "name": "BestMarsBotanist",
        "path": "scarworld/6/BestMarsBotanist"
      },
      {
        "name": "Blueastrosailor",
        "path": "scarworld/6/Blueastrosailor"
      },
      {
        "name": "Bluecrow642",
        "path": "scarworld/6/Bluecrow642"
      },
      {
        "name": "BossyBear",
        "path": "scarworld/6/BossyBear"
      },
      {
        "name": "BossyHare",
        "path": "scarworld/6/BossyHare"
      },
      {
        "name": "btechdog",
        "path": "scarworld/6/btechdog"
      },
      {
        "name": "cat1dog",
        "path": "scarworld/6/cat1dog"
      },
      {
        "name": "CatKiwiFish",
        "path": "scarworld/6/CatKiwiFish"
      },
      {
        "name": "Chrisnessity",
        "path": "scarworld/6/Chrisnessity"
      },
      {
        "name": "cloudninemeeple",
        "path": "scarworld/6/cloudninemeeple"
      },
      {
        "name": "Cotenzia",
        "path": "scarworld/6/Cotenzia"
      },
      {
        "name": "CurtTheRed",
        "path": "scarworld/6/CurtTheRed"
      },
      {
        "name": "Dollsmyname",
        "path": "scarworld/6/Dollsmyname"
      },
      {
        "name": "DuckOmega",
        "path": "scarworld/6/DuckOmega"
      },
      {
        "name": "Elednor89",
        "path": "scarworld/6/Elednor89"
      },
      {
        "name": "EvergreenVenus",
        "path": "scarworld/6/EvergreenVenus"
      },
      {
        "name": "Fungi_2022",
        "path": "scarworld/6/Fungi_2022"
      },
      {
        "name": "GINGY101",
        "path": "scarworld/6/GINGY101"
      },
      {
        "name": "GlasSandPlane",
        "path": "scarworld/6/GlasSandPlane"
      },
      {
        "name": "hoverfloat",
        "path": "scarworld/6/hoverfloat"
      },
      {
        "name": "IantheSilverfire",
        "path": "scarworld/6/IantheSilverfire"
      },
      {
        "name": "jiantings",
        "path": "scarworld/6/jiantings"
      },
      {
        "name": "KillerSquirre1",
        "path": "scarworld/6/KillerSquirre1"
      },
      {
        "name": "KillerSquirre1 (Alt)",
        "path": "scarworld/6/KillerSquirre1_alt"
      },
      {
        "name": "ListenLynda85",
        "path": "scarworld/6/ListenLynda85"
      },
      {
        "name": "Loddie",
        "path": "scarworld/6/Loddie"
      },
      {
        "name": "Lupa_Buchanan",
        "path": "scarworld/6/Lupa_Buchanan"
      },
      {
        "name": "MaddenChan",
        "path": "scarworld/6/MaddenChan"
      },
      {
        "name": "MaddiG359",
        "path": "scarworld/6/MaddiG359"
      },
      {
        "name": "Madiza",
        "path": "scarworld/6/Madiza"
      },
      {
        "name": "MaziCrafter",
        "path": "scarworld/6/MaziCrafter"
      },
      {
        "name": "Mimi_Dev",
        "path": "scarworld/6/Mimi_Dev"
      },
      {
        "name": "MithicalMoon",
        "path": "scarworld/6/MithicalMoon"
      },
      {
        "name": "ModigMaestro",
        "path": "scarworld/6/ModigMaestro"
      },
      {
        "name": "MrStrigoi",
        "path": "scarworld/6/MrStrigoi"
      },
      {
        "name": "MsKakapo",
        "path": "scarworld/6/MsKakapo"
      },
      {
        "name": "nommaster_33",
        "path": "scarworld/6/nommaster_33"
      },
      {
        "name": "ObiWanTano",
        "path": "scarworld/6/ObiWanTano"
      },
      {
        "name": "OracleMask",
        "path": "scarworld/6/OracleMask"
      },
      {
        "name": "PerfectlyFlawed_",
        "path": "scarworld/6/PerfectlyFlawed_"
      },
      {
        "name": "PhoenixBunny456",
        "path": "scarworld/6/PhoenixBunny456"
      },
      {
        "name": "PinkCreeper18",
        "path": "scarworld/6/PinkCreeper18"
      },
      {
        "name": "QueenieCrafter",
        "path": "scarworld/6/QueenieCrafter"
      },
      {
        "name": "Razoria",
        "path": "scarworld/6/Razoria"
      },
      {
        "name": "Retrohug",
        "path": "scarworld/6/Retrohug"
      },
      {
        "name": "shnozberrycake",
        "path": "scarworld/6/shnozberrycake"
      },
      {
        "name": "Shyacross",
        "path": "scarworld/6/Shyacross"
      },
      {
        "name": "Sinopa1327",
        "path": "scarworld/6/Sinopa1327"
      },
      {
        "name": "Sr_Cro",
        "path": "scarworld/6/Sr_Cro"
      },
      {
        "name": "StarryStorm98",
        "path": "scarworld/6/StarryStorm98"
      },
      {
        "name": "Stormhawke7",
        "path": "scarworld/6/Stormhawke7"
      },
      {
        "name": "Synoat",
        "path": "scarworld/6/Synoat"
      },
      {
        "name": "TactfulAcorn265",
        "path": "scarworld/6/TactfulAcorn265"
      },
      {
        "name": "Taterchip",
        "path": "scarworld/6/Taterchip"
      },
      {
        "name": "TayAndy",
        "path": "scarworld/6/TayAndy"
      },
      {
        "name": "teddiezs",
        "path": "scarworld/6/teddiezs"
      },
      {
        "name": "Terraglows",
        "path": "scarworld/6/Terraglows"
      },
      {
        "name": "that_Bonsai",
        "path": "scarworld/6/that_Bonsai"
      },
      {
        "name": "ThripleRex",
        "path": "scarworld/6/ThripleRex"
      },
      {
        "name": "Wandering_Mask",
        "path": "scarworld/6/Wandering_Mask"
      }
    ]
  },
  {
    "name": "Zedcraft Season 7",
    "code": "zedcraft-s7",
    "plushies": [
      {
        "name": "AddiVF",
        "path": "zedcraft/7/AddiVF"
      },
      {
        "name": "AlexMakeMonsters",
        "path": "zedcraft/7/AlexMakeMonsters"
      },
      {
        "name": "Artemisbrine",
        "path": "zedcraft/7/Artemisbrine"
      },
      {
        "name": "beesquestionmark",
        "path": "zedcraft/7/beesquestionmark"
      },
      {
        "name": "Boonsi",
        "path": "zedcraft/7/Boonsi"
      },
      {
        "name": "ChaoticKaiju",
        "path": "zedcraft/7/ChaoticKaiju"
      },
      {
        "name": "ChloeLeigh",
        "path": "zedcraft/7/ChloeLeigh"
      },
      {
        "name": "cloudninemeeple",
        "path": "zedcraft/7/cloudninemeeple"
      },
      {
        "name": "Codex404",
        "path": "zedcraft/7/Codex404"
      },
      {
        "name": "CyndaMagius",
        "path": "zedcraft/7/CyndaMagius"
      },
      {
        "name": "Deuterium_",
        "path": "zedcraft/7/Deuterium_"
      },
      {
        "name": "diamondrules1",
        "path": "zedcraft/7/diamondrules1"
      },
      {
        "name": "dkmuldoon",
        "path": "zedcraft/7/dkmuldoon"
      },
      {
        "name": "Duckyshark101",
        "path": "zedcraft/7/Duckyshark101"
      },
      {
        "name": "evilshews",
        "path": "zedcraft/7/evilshews"
      },
      {
        "name": "FindingHippie",
        "path": "zedcraft/7/FindingHippie"
      },
      {
        "name": "FloppyMcCopy V2",
        "path": "zedcraft/7/FloppyMcCopy_v2"
      },
      {
        "name": "GeneralXabierosa",
        "path": "zedcraft/7/GeneralXabierosa"
      },
      {
        "name": "Ghostkeeper1",
        "path": "zedcraft/7/Ghostkeeper1"
      },
      {
        "name": "InfiniteClam",
        "path": "zedcraft/7/InfiniteClam"
      },
      {
        "name": "Jademelodyca",
        "path": "zedcraft/7/Jademelodyca"
      },
      {
        "name": "Jadeturtle",
        "path": "zedcraft/7/Jadeturtle"
      },
      {
        "name": "JustJaemi",
        "path": "zedcraft/7/JustJaemi"
      },
      {
        "name": "Karaon",
        "path": "zedcraft/7/Karaon"
      },
      {
        "name": "KirVulpes",
        "path": "zedcraft/7/KirVulpes"
      },
      {
        "name": "Kraafty_Chik",
        "path": "zedcraft/7/Kraafty_Chik"
      },
      {
        "name": "Lucifyn",
        "path": "zedcraft/7/Lucifyn"
      },
      {
        "name": "MamaKangaroo",
        "path": "zedcraft/7/MamaKangaroo"
      },
      {
        "name": "marsdin",
        "path": "zedcraft/7/marsdin"
      },
      {
        "name": "maviricks",
        "path": "zedcraft/7/maviricks"
      },
      {
        "name": "MaziCrafter",
        "path": "zedcraft/7/MaziCrafter"
      },
      {
        "name": "Mel_Playz_Gamez",
        "path": "zedcraft/7/Mel_Playz_Gamez"
      },
      {
        "name": "Miakota",
        "path": "zedcraft/7/Miakota"
      },
      {
        "name": "Mistycle",
        "path": "zedcraft/7/Mistycle"
      },
      {
        "name": "Morgoth_Ariendi",
        "path": "zedcraft/7/Morgoth_Ariendi"
      },
      {
        "name": "Morphix252",
        "path": "zedcraft/7/Morphix252"
      },
      {
        "name": "MrMystery19",
        "path": "zedcraft/7/MrMystery19"
      },
      {
        "name": "Nick42Dent",
        "path": "zedcraft/7/Nick42Dent"
      },
      {
        "name": "NoodleNam",
        "path": "zedcraft/7/NoodleNam"
      },
      {
        "name": "plmi1",
        "path": "zedcraft/7/plmi1"
      },
      {
        "name": "PrincessCat15",
        "path": "zedcraft/7/PrincessCat15"
      },
      {
        "name": "RedShirtDown",
        "path": "zedcraft/7/RedShirtDown"
      },
      {
        "name": "Salsareno",
        "path": "zedcraft/7/Salsareno"
      },
      {
        "name": "ScriblesDaScribe",
        "path": "zedcraft/7/ScriblesDaScribe"
      },
      {
        "name": "seymour47",
        "path": "zedcraft/7/seymour47"
      },
      {
        "name": "ShunnedTomcat",
        "path": "zedcraft/7/ShunnedTomcat"
      },
      {
        "name": "Snipstea",
        "path": "zedcraft/7/Snipstea"
      },
      {
        "name": "SnowAvenger",
        "path": "zedcraft/7/SnowAvenger"
      },
      {
        "name": "softmonkey",
        "path": "zedcraft/7/softmonkey"
      },
      {
        "name": "SuperUsername",
        "path": "zedcraft/7/SuperUsername"
      },
      {
        "name": "The_Jade_Turtle",
        "path": "zedcraft/7/The_Jade_Turtle"
      },
      {
        "name": "TheBatWalrus",
        "path": "zedcraft/7/TheBatWalrus"
      },
      {
        "name": "TheElusiveDJ",
        "path": "zedcraft/7/TheElusiveDJ"
      },
      {
        "name": "TheRockLlama",
        "path": "zedcraft/7/TheRockLlama"
      },
      {
        "name": "Trix465",
        "path": "zedcraft/7/Trix465"
      },
      {
        "name": "Vorticia1184",
        "path": "zedcraft/7/Vorticia1184"
      },
      {
        "name": "WhiskersMcGee",
        "path": "zedcraft/7/WhiskersMcGee"
      },
      {
        "name": "Xyro27",
        "path": "zedcraft/7/Xyro27"
      },
      {
        "name": "YoungGun970",
        "path": "zedcraft/7/YoungGun970"
      }
    ]
  },
  {
    "name": "HermitCraft Season 9",
    "code": "hermitcraft-s9",
    "plushies": [
      {
        "name": "BdoubleO100",
        "path": "hermitcraft/9/BdoubleO100"
      },
      {
        "name": "cubfan135",
        "path": "hermitcraft/9/cubfan135"
      },
      {
        "name": "Docm77",
        "path": "hermitcraft/9/Docm77"
      },
      {
        "name": "EthosLab",
        "path": "hermitcraft/9/EthosLab"
      },
      {
        "name": "FalseSymmetry",
        "path": "hermitcraft/9/FalseSymmetry"
      },
      {
        "name": "GeminiTay",
        "path": "hermitcraft/9/GeminiTay"
      },
      {
        "name": "GoodTimeWithScar",
        "path": "hermitcraft/9/GoodTimeWithScar"
      },
      {
        "name": "Grian",
        "path": "hermitcraft/9/Grian"
      },
      {
        "name": "Hypnotizd",
        "path": "hermitcraft/9/Hypnotizd"
      },
      {
        "name": "iJevin",
        "path": "hermitcraft/9/iJevin"
      },
      {
        "name": "ImpulseSV",
        "path": "hermitcraft/9/ImpulseSV"
      },
      {
        "name": "joehillssays",
        "path": "hermitcraft/9/joehillssays"
      },
      {
        "name": "Keralis",
        "path": "hermitcraft/9/Keralis"
      },
      {
        "name": "Mumbo",
        "path": "hermitcraft/9/Mumbo"
      },
      {
        "name": "PearlescentMoon",
        "path": "hermitcraft/9/PearlescentMoon"
      },
      {
        "name": "Rendog",
        "path": "hermitcraft/9/Rendog"
      },
      {
        "name": "Tango",
        "path": "hermitcraft/9/Tango"
      },
      {
        "name": "Tinfoilchef",
        "path": "hermitcraft/9/Tinfoilchef"
      },
      {
        "name": "VintageBeef",
        "path": "hermitcraft/9/VintageBeef"
      },
      {
        "name": "Welsknight",
        "path": "hermitcraft/9/Welsknight"
      },
      {
        "name": "xBCrafted",
        "path": "hermitcraft/9/xBCrafted"
      },
      {
        "name": "Xisumavoid",
        "path": "hermitcraft/9/Xisumavoid"
      },
      {
        "name": "Zedaph",
        "path": "hermitcraft/9/Zedaph"
      },
      {
        "name": "ZombieCleo",
        "path": "hermitcraft/9/ZombieCleo"
      }
    ]
  },
  {
    "name": "HermitCraft Season 10",
    "code": "hermitcraft-s10",
    "plushies": [
      {
        "name": "BdoubleO100",
        "path": "hermitcraft/10/BdoubleO100"
      },
      {
        "name": "cubfan135",
        "path": "hermitcraft/10/cubfan135"
      },
      {
        "name": "Docm77",
        "path": "hermitcraft/10/Docm77"
      },
      {
        "name": "EthosLab",
        "path": "hermitcraft/10/EthosLab"
      },
      {
        "name": "FalseSymmetry",
        "path": "hermitcraft/10/FalseSymmetry"
      },
      {
        "name": "GeminiTay",
        "path": "hermitcraft/10/GeminiTay"
      },
      {
        "name": "GoodTimeWithScar",
        "path": "hermitcraft/10/GoodTimeWithScar"
      },
      {
        "name": "Grian",
        "path": "hermitcraft/10/Grian"
      },
      {
        "name": "Hypnotizd",
        "path": "hermitcraft/10/Hypnotizd"
      },
      {
        "name": "iJevin",
        "path": "hermitcraft/10/iJevin"
      },
      {
        "name": "ImpulseSV",
        "path": "hermitcraft/10/ImpulseSV"
      },
      {
        "name": "joehillssays",
        "path": "hermitcraft/10/joehillssays"
      },
      {
        "name": "Keralis",
        "path": "hermitcraft/10/Keralis"
      },
      {
        "name": "Mumbo",
        "path": "hermitcraft/10/Mumbo"
      },
      {
        "name": "PearlescentMoon",
        "path": "hermitcraft/10/PearlescentMoon"
      },
      {
        "name": "Rendog",
        "path": "hermitcraft/10/Rendog"
      },
      {
        "name": "Skizzleman",
        "path": "hermitcraft/10/Skizzleman"
      },
      {
        "name": "Smallishbeans",
        "path": "hermitcraft/10/Smallishbeans"
      },
      {
        "name": "Tango",
        "path": "hermitcraft/10/Tango"
      },
      {
        "name": "Tinfoilchef",
        "path": "hermitcraft/10/Tinfoilchef"
      },
      {
        "name": "VintageBeef",
        "path": "hermitcraft/10/VintageBeef"
      },
      {
        "name": "Welsknight",
        "path": "hermitcraft/10/Welsknight"
      },
      {
        "name": "xBCrafted",
        "path": "hermitcraft/10/xBCrafted"
      },
      {
        "name": "Xisuma",
        "path": "hermitcraft/10/Xisuma"
      },
      {
        "name": "Zedaph",
        "path": "hermitcraft/10/Zedaph"
      },
      {
        "name": "ZombieCleo",
        "path": "hermitcraft/10/ZombieCleo"
      }
    ]
  },
  {
    "name": "HermitCraft Season 11",
    "code": "hermitcraft-s11",
    "plushies": [
      {
        "name": "BdoubleO100",
        "path": "hermitcraft/11/BdoubleO100"
      },
      {
        "name": "cubfan135",
        "path": "hermitcraft/11/cubfan135"
      },
      {
        "name": "Docm77",
        "path": "hermitcraft/11/Docm77"
      },
      {
        "name": "EthosLab",
        "path": "hermitcraft/11/EthosLab"
      },
      {
        "name": "FalseSymmetry",
        "path": "hermitcraft/11/FalseSymmetry"
      },
      {
        "name": "GeminiTay",
        "path": "hermitcraft/11/GeminiTay"
      },
      {
        "name": "GoodTimeWithScar",
        "path": "hermitcraft/11/GoodTimeWithScar"
      },
      {
        "name": "Monopoly Scar",
        "path": "hermitcraft/11/MonopolyScar"
      },
      {
        "name": "Grian",
        "path": "hermitcraft/11/Grian"
      },
      {
        "name": "Hypnotizd",
        "path": "hermitcraft/11/Hypnotizd"
      },
      {
        "name": "iJevin",
        "path": "hermitcraft/11/iJevin"
      },
      {
        "name": "ImpulseSV",
        "path": "hermitcraft/11/ImpulseSV"
      },
      {
        "name": "joehillssays",
        "path": "hermitcraft/11/joehillssays"
      },
      {
        "name": "Keralis",
        "path": "hermitcraft/11/Keralis"
      },
      {
        "name": "Emperor Keralis",
        "path": "hermitcraft/11/EmperorKeralis"
      },
      {
        "name": "Mumbo",
        "path": "hermitcraft/11/Mumbo"
      },
      {
        "name": "PearlescentMoon",
        "path": "hermitcraft/11/PearlescentMoon"
      },
      {
        "name": "Renthedog",
        "path": "hermitcraft/11/Renthedog"
      },
      {
        "name": "Skizzleman",
        "path": "hermitcraft/11/Skizzleman"
      },
      {
        "name": "Smallishbeans",
        "path": "hermitcraft/11/Smallishbeans"
      },
      {
        "name": "Tango",
        "path": "hermitcraft/11/Tango"
      },
      {
        "name": "VintageBeef",
        "path": "hermitcraft/11/VintageBeef"
      },
      {
        "name": "Welsknight",
        "path": "hermitcraft/11/Welsknight"
      },
      {
        "name": "xBCrafted",
        "path": "hermitcraft/11/xBCrafted"
      },
      {
        "name": "Xisuma",
        "path": "hermitcraft/11/Xisuma"
      },
      {
        "name": "Zedaph",
        "path": "hermitcraft/11/Zedaph"
      },
      {
        "name": "ZombieCleo",
        "path": "hermitcraft/11/ZombieCleo"
      }
    ]
  },
  {
    "name": "Minecraft Mobs",
    "code": "minecraft",
    "plushies": [
      {
        "name": "Alex",
        "path": "minecraft/alex"
      },
      {
        "name": "Black Cat",
        "path": "minecraft/cat_black"
      },
      {
        "name": "British Shorthair Cat",
        "path": "minecraft/cat_british_shorthair"
      },
      {
        "name": "Brown Tabby Cat",
        "path": "minecraft/cat_brown_tabby"
      },
      {
        "name": "Calico Cat",
        "path": "minecraft/cat_calico"
      },
      {
        "name": "Gray Tabby Cat",
        "path": "minecraft/cat_gray_tabby"
      },
      {
        "name": "Jellie Cat",
        "path": "minecraft/cat_jellie"
      },
      {
        "name": "Orange Tabby Cat",
        "path": "minecraft/cat_orange_tabby"
      },
      {
        "name": "Persian Cat",
        "path": "minecraft/cat_persian"
      },
      {
        "name": "Ragdoll Cat",
        "path": "minecraft/cat_ragdoll"
      },
      {
        "name": "Siamese Cat",
        "path": "minecraft/cat_siamese"
      },
      {
        "name": "Tuxedo Cat",
        "path": "minecraft/cat_tuxedo"
      },
      {
        "name": "White Cat",
        "path": "minecraft/cat_white"
      },
      {
        "name": "Chicken",
        "path": "minecraft/chicken"
      },
      {
        "name": "Cow",
        "path": "minecraft/cow"
      },
      {
        "name": "Creeper",
        "path": "minecraft/creeper"
      },
      {
        "name": "Enderman",
        "path": "minecraft/enderman"
      },
      {
        "name": "Ghast",
        "path": "minecraft/ghast"
      },
      {
        "name": "Mooshroom",
        "path": "minecraft/mooshroom"
      },
      {
        "name": "Ocelot",
        "path": "minecraft/ocelot"
      },
      {
        "name": "Pig",
        "path": "minecraft/pig"
      },
      {
        "name": "Sheep",
        "path": "minecraft/sheep"
      },
      {
        "name": "Shulker",
        "path": "minecraft/shulker"
      },
      {
        "name": "Skeleton",
        "path": "minecraft/skeleton"
      },
      {
        "name": "Steve",
        "path": "minecraft/steve"
      },
      {
        "name": "Zombie",
        "path": "minecraft/zombie"
      }
    ]
  },
  {
    "name": "Star Wars",
    "code": "starwars",
    "plushies": [
      {
        "name": "Admiral Ackbar",
        "path": "starwars/ackbar"
      },
      {
        "name": "Boba Fett",
        "path": "starwars/boba"
      },
      {
        "name": "C3PO",
        "path": "starwars/c3po"
      },
      {
        "name": "Cantina Band Musician",
        "path": "starwars/cantina_band"
      },
      {
        "name": "Chewbacca",
        "path": "starwars/chewie"
      },
      {
        "name": "Ewok",
        "path": "starwars/ewok"
      },
      {
        "name": "Grand Moff Tarkin",
        "path": "starwars/grand_moff_tarkin"
      },
      {
        "name": "Greedo",
        "path": "starwars/greedo"
      },
      {
        "name": "Grogu",
        "path": "starwars/grogu"
      },
      {
        "name": "Grogu in Pod",
        "path": "starwars/grogu_pod"
      },
      {
        "name": "Han Solo",
        "path": "starwars/han"
      },
      {
        "name": "Imperial Guard",
        "path": "starwars/imperial_guard"
      },
      {
        "name": "Imperial Officer",
        "path": "starwars/imperial_officer"
      },
      {
        "name": "Jabba the Hutt",
        "path": "starwars/jabba"
      },
      {
        "name": "Jawa",
        "path": "starwars/jawa"
      },
      {
        "name": "Lando Calrissian",
        "path": "starwars/lando"
      },
      {
        "name": "Leia Organa (Episode IV)",
        "path": "starwars/leia_epIV"
      },
      {
        "name": "Leia Organa (Episode VI)",
        "path": "starwars/leia_epVI"
      },
      {
        "name": "Luke Skywalker (Episode IV)",
        "path": "starwars/luke_epIV"
      },
      {
        "name": "Luke Skywalker Red 5 (Episode IV)",
        "path": "starwars/luke_epIV_red5"
      },
      {
        "name": "Luke Skywalker (Episode VI)",
        "path": "starwars/luke_epVI"
      },
      {
        "name": "The Mandalorian",
        "path": "starwars/mando"
      },
      {
        "name": "Obi Wan Kenobi",
        "path": "starwars/obi_wan"
      },
      {
        "name": "Emperor Palpatine",
        "path": "starwars/palpatine"
      },
      {
        "name": "R2D2",
        "path": "starwars/r2d2"
      },
      {
        "name": "Rebel Fighter",
        "path": "starwars/rebel_fighter"
      },
      {
        "name": "Stormtrooper",
        "path": "starwars/storm_trooper"
      },
      {
        "name": "Tuscan Raider",
        "path": "starwars/tuscan_raider"
      },
      {
        "name": "Darth Vader",
        "path": "starwars/vader"
      },
      {
        "name": "Yoda",
        "path": "starwars/yoda"
      }
    ]
  }
];